<script setup lang="ts">
import LGHowToUseContent from "~/components/partials/LGHowToUseContent.vue";

const items = [
    {
        name: 'Kupi vodič v spletni trgovini',
        review: 'Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh. '
    },
    {
        name: 'Aktiviraj vodič v 7 dneh od nakupa',
        review: 'Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh. '
    },
    {
        name: 'Prepusti telefon otroku',
        review: 'Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh. '
    },
]
</script>

<template>
    <section class="pt-12 sm:pt-12 pb-24 sm:pb-36 relative overflow-x-clip">
        <NuxtImg src="/images/shop/shop-pin.svg" alt="Pin" class="hidden lg:block lg:w-[95px] absolute lg:top-0 lg:right-16" />
        <LGHowToUseContent/>
    </section>
</template>

<style scoped>

</style>
